<template>
  <div>
    <h3 v-if="!hideHeader">
      {{ $t('phrase.register_research') }}
      <small class="text-muted">{{
          $t('word.general_info')
            .toLowerCase()
        }}</small>
    </h3>

    <form method="post" @submit.prevent="$emit('submit')">
      <v-research-form
        :form-data="formData"
        :errors="errors"
        :allow-created-by="false"
        :allow-categories="false"
        :allow-published="false"
      />
    </form>
  </div>
</template>

<script>
import { fetchCommercialCategories } from '@/organisation/api';
import { mapGetters } from 'vuex';
import ResearchForm from '@/common/components/research/ResearchForm.vue';

export default {
  name: 'ResearchFormRadio',
  components: {
    'v-research-form': ResearchForm,
  },
  props: {
    hideHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    research: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      errors: {},
      loader: { loading: false },
      categories: null,
      formData: {
        title: '',
        description: '',
        group_size: 250,
      },
    };
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    processFile(event) {
      const file = event.target.files[0];

      if (file.size / 1024 / 1024 > 5) {
        this.fileErrors = [this.$t('sentence.file_too_large')];
        return;
      }

      file.url = URL.createObjectURL(file);
      this.formData.media_file = file;
      this.$emit('valid-form');
    },
    async getCommercialCategories() {
      const response = await fetchCommercialCategories();
      this.categories = response.data.map((el) => ({
        id: el.id,
        name: el.name,
      }));
    },
    validate() {
      this.errors = {};
      let isValid = true;
      if (!this.formData.title) {
        this.errors = {
          ...this.errors,
          title: [this.$t('phrase.field_required')],
        };
        isValid = false;
      }
      if (isValid) {
        return this.formData;
      }
      return null;
    },
  },
  created() {
    if (this.research) {
      this.formData = {
        title: this.research.title,
        description: this.research.description,
        group_size: 250,
      };
    }
  },
  mounted() {
    this.$emit('valid-form');
  },
};
</script>
